import { render, staticRenderFns } from "./updatepassword.vue?vue&type=template&id=44c154ba&"
import script from "./updatepassword.vue?vue&type=script&lang=js&"
export * from "./updatepassword.vue?vue&type=script&lang=js&"
import style0 from "./updatepassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports